module.exports = __webpack_public_path__ + "img/9-4.b498cd2b.jpg";